import React from 'react';
import { Moon, Sun, Monitor } from 'lucide-react';
import { useTheme } from '@/contexts/ThemeContext';
import { THEME_LOCKED_FOR_PILOT } from '@/config/pilot';

export const ThemeToggle: React.FC = () => {
    const { theme, setTheme } = useTheme();

    if (THEME_LOCKED_FOR_PILOT) return null;

    const cycleTheme = () => {
        if (theme === 'system') setTheme('light');
        else if (theme === 'light') setTheme('soft-light');
        else if (theme === 'soft-light') setTheme('dark');
        else setTheme('system');
    };

    const getIcon = () => {
        if (theme === 'light') return <Sun size={18} />;
        if (theme === 'soft-light') return <Sun size={18} className="opacity-70" />;
        if (theme === 'system') return <Monitor size={18} />;
        return <Moon size={18} />;
    };

    const getLabel = () => {
        if (theme === 'light') return 'Light Mode';
        if (theme === 'soft-light') return 'Soft Light Mode';
        if (theme === 'system') return 'System Theme';
        return 'Dark Mode';
    };

    return (
        <button
            onClick={cycleTheme}
            className="flex items-center justify-center p-3 rounded-xl transition-all duration-200 text-text-secondary hover:bg-surface-hover hover:text-text-primary group border border-divider-subtle bg-bg-primary/20 cursor-pointer"
            title={`Current: ${getLabel()} (Click to cycle)`}
        >
            <div className="transition-transform duration-300 group-hover:scale-110 text-accent-electric">
                {getIcon()}
            </div>
        </button>
    );
};
